import { environment } from 'src/environments/environment';

export const primengIcons = [
  'pi pi-align-center',
  'pi pi-align-justify',
  'pi pi-align-left',
  'pi pi-align-right',
  'pi pi-amazon',
  'pi pi-android',
  'pi pi-angle-double-down',
  'pi pi-angle-double-left',
  'pi pi-angle-double-right',
  'pi pi-angle-double-up',
  'pi pi-angle-down',
  'pi pi-angle-left',
  'pi pi-angle-right',
  'pi pi-angle-up',
  'pi pi-apple',
  'pi pi-arrow-circle-down',
  'pi pi-arrow-circle-left',
  'pi pi-arrow-circle-right',
  'pi pi-arrow-circle-up',
  'pi pi-arrow-down',
  'pi pi-arrow-down-left',
  'pi pi-arrow-down-right',
  'pi pi-arrow-left',
  'pi pi-arrow-right',
  'pi pi-arrow-right-arrow-left',
  'pi pi-arrow-up',
  'pi pi-arrow-up-left',
  'pi pi-arrow-up-right',
  'pi pi-arrows-alt',
  'pi pi-arrows-h',
  'pi pi-arrows-v',
  'pi pi-at',
  'pi pi-backward',
  'pi pi-ban',
  'pi pi-bars',
  'pi pi-bell',
  'pi pi-bitcoin',
  'pi pi-bolt',
  'pi pi-book',
  'pi pi-bookmark',
  'pi pi-bookmark-fill',
  'pi pi-box',
  'pi pi-briefcase',
  'pi pi-building',
  'pi pi-calculator',
  'pi pi-calendar',
  'pi pi-calendar-minus',
  'pi pi-calendar-plus',
  'pi pi-calendar-times',
  'pi pi-camera',
  'pi pi-car',
  'pi pi-caret-down',
  'pi pi-caret-left',
  'pi pi-caret-right',
  'pi pi-caret-up',
  'pi pi-cart-plus',
  'pi pi-chart-bar',
  'pi pi-chart-line',
  'pi pi-chart-pie',
  'pi pi-check',
  'pi pi-check-circle',
  'pi pi-check-square',
  'pi pi-chevron-circle-down',
  'pi pi-chevron-circle-left',
  'pi pi-chevron-circle-right',
  'pi pi-chevron-circle-up',
  'pi pi-chevron-down',
  'pi pi-chevron-left',
  'pi pi-chevron-right',
  'pi pi-chevron-up',
  'pi pi-circle',
  'pi pi-circle-fill',
  'pi pi-circle-off',
  'pi pi-circle-on',
  'pi pi-clock',
  'pi pi-clone',
  'pi pi-cloud',
  'pi pi-cloud-download',
  'pi pi-cloud-upload',
  'pi pi-code',
  'pi pi-cog',
  'pi pi-comment',
  'pi pi-comments',
  'pi pi-compass',
  'pi pi-copy',
  'pi pi-credit-card',
  'pi pi-database',
  'pi pi-delete-left',
  'pi pi-desktop',
  'pi pi-directions',
  'pi pi-directions-alt',
  'pi pi-discord',
  'pi pi-dollar',
  'pi pi-download',
  'pi pi-eject',
  'pi pi-ellipsis-h',
  'pi pi-ellipsis-v',
  'pi pi-envelope',
  'pi pi-eraser',
  'pi pi-euro',
  'pi pi-exclamation-circle',
  'pi pi-exclamation-triangle',
  'pi pi-external-link',
  'pi pi-eye',
  'pi pi-eye-slash',
  'pi pi-facebook',
  'pi pi-fast-backward',
  'pi pi-fast-forward',
  'pi pi-file',
  'pi pi-file-edit',
  'pi pi-file-excel',
  'pi pi-file-export',
  'pi pi-file-import',
  'pi pi-file-o',
  'pi pi-file-pdf',
  'pi pi-file-word',
  'pi pi-filter',
  'pi pi-filter-fill',
  'pi pi-filter-slash',
  'pi pi-flag',
  'pi pi-flag-fill',
  'pi pi-folder',
  'pi pi-folder-open',
  'pi pi-forward',
  'pi pi-gift',
  'pi pi-github',
  'pi pi-globe',
  'pi pi-google',
  'pi pi-hashtag',
  'pi pi-heart',
  'pi pi-heart-fill',
  'pi pi-history',
  'pi pi-home',
  'pi pi-hourglass',
  'pi pi-id-card',
  'pi pi-image',
  'pi pi-images',
  'pi pi-inbox',
  'pi pi-info',
  'pi pi-info-circle',
  'pi pi-instagram',
  'pi pi-key',
  'pi pi-language',
  'pi pi-link',
  'pi pi-linkedin',
  'pi pi-list',
  'pi pi-lock',
  'pi pi-lock-open',
  'pi pi-map',
  'pi pi-map-marker',
  'pi pi-megaphone',
  'pi pi-microphone',
  'pi pi-microsoft',
  'pi pi-minus',
  'pi pi-minus-circle',
  'pi pi-mobile',
  'pi pi-money-bill',
  'pi pi-moon',
  'pi pi-palette',
  'pi pi-paperclip',
  'pi pi-pause',
  'pi pi-paypal',
  'pi pi-pencil',
  'pi pi-percentage',
  'pi pi-phone',
  'pi pi-play',
  'pi pi-plus',
  'pi pi-plus-circle',
  'pi pi-pound',
  'pi pi-power-off',
  'pi pi-prime',
  'pi pi-print',
  'pi pi-qrcode',
  'pi pi-question',
  'pi pi-question-circle',
  'pi pi-reddit',
  'pi pi-refresh',
  'pi pi-replay',
  'pi pi-reply',
  'pi pi-save',
  'pi pi-search',
  'pi pi-search-minus',
  'pi pi-search-plus',
  'pi pi-send',
  'pi pi-server',
  'pi pi-share-alt',
  'pi pi-shield',
  'pi pi-shopping-bag',
  'pi pi-shopping-cart',
  'pi pi-sign-in',
  'pi pi-sign-out',
  'pi pi-sitemap',
  'pi pi-slack',
  'pi pi-sliders-h',
  'pi pi-sliders-v',
  'pi pi-sort',
  'pi pi-sort-alpha-down',
  'pi pi-sort-alpha-down-alt',
  'pi pi-sort-alpha-up',
  'pi pi-sort-alpha-up-alt',
  'pi pi-sort-alt',
  'pi pi-sort-alt-slash',
  'pi pi-sort-amount-down',
  'pi pi-sort-amount-down-alt',
  'pi pi-sort-amount-up',
  'pi pi-sort-amount-up-alt',
  'pi pi-sort-down',
  'pi pi-sort-down-fill',
  'pi pi-sort-numeric-down',
  'pi pi-sort-numeric-down-alt',
  'pi pi-sort-numeric-up',
  'pi pi-sort-numeric-up-alt',
  'pi pi-sort-up',
  'pi pi-sparkles',
  'pi pi-spinner',
  'pi pi-spinner-dotted',
  'pi pi-star',
  'pi pi-star-fill',
  'pi pi-star-half',
  'pi pi-star-half-fill',
  'pi pi-step-backward',
  'pi pi-step-backward-alt',
  'pi pi-step-forward',
  'pi pi-step-forward-alt',
  'pi pi-stop',
  'pi pi-stop-circle',
  'pi pi-stopwatch',
  'pi pi-sun',
  'pi pi-sync',
  'pi pi-table',
  'pi pi-tablet',
  'pi pi-tag',
  'pi pi-tags',
  'pi pi-telegram',
  'pi pi-th-large',
  'pi pi-thumbs-down',
  'pi pi-thumbs-down-fill',
  'pi pi-thumbs-up',
  'pi pi-thumbs-up-fill',
  'pi pi-thumbtack',
  'pi pi-ticket',
  'pi pi-tiktok',
  'pi pi-times',
  'pi pi-times-circle',
  'pi pi-trash',
  'pi pi-trophy',
  'pi pi-truck',
  'pi pi-turkish-lira',
  'pi pi-twitch',
  'pi pi-twitter',
  'pi pi-undo',
  'pi pi-unlock',
  'pi pi-upload',
  'pi pi-user',
  'pi pi-user-edit',
  'pi pi-user-minus',
  'pi pi-user-plus',
  'pi pi-users',
  'pi pi-venus',
  'pi pi-verified',
  'pi pi-video',
  'pi pi-vimeo',
  'pi pi-volume-down',
  'pi pi-volume-off',
  'pi pi-volume-up',
  'pi pi-wallet',
  'pi pi-warehouse',
  'pi pi-wave-pulse',
  'pi pi-whatsapp',
  'pi pi-wifi',
  'pi pi-window-maximize',
  'pi pi-window-minimize',
  'pi pi-wrench',
  'pi pi-youtube',
];

const topLevelDomainArray = ['com', 'org', 'net', 'gov', 'edu', 'info', 'biz', 'co', 'uk', 'de', 'nl', 'ru', 'cn', 'au', 'fr', 'ca', 'jp', 'it', 'br', 'es', 'in', 'mil'];
const regexString = `[a-z][a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z][a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+(?:${topLevelDomainArray.join(
  '|',
)}{2,6})\\b`;

export const Constants = {
  dockWindowEnabled: true,
  applicationLogoUrl: 'assets/images/cep-logo.svg',
  applicationLogoDarkUrl: 'assets/images/cep-dark-logo.svg',
  environmentsForErrorTracing: ['localhost', environment.hostUrl],
  splashScreenTimeout: 200,
  dateFormat: 'MM/dd/yyyy',
  dateTimeISO8601Formate: 'yyyy-MM-ddTHH:mm:ssZZZZZ',
  pattern: {
    PASSWORD_PATTERN: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/),
    URL_PATTERN: new RegExp(/^(https?|ftp):\/\/(?:\w+\.)?[^\/\s$?#].[^\s]*$/),
    NAME: new RegExp(/^[a-zA-Z]{3,} [a-zA-Z]{3,}$/),
    PROJECT_NAME: new RegExp(/^([0-9]+[a-zA-Z]*(-|_)?)?[a-zA-Z]+[0-9]*((\s)?[0-9]*[a-zA-Z]+[0-9]*)?$/),
    PHONE_NUMBER_PATTERN: new RegExp(/^(?:(?:\+91[\s-]?)?(?:6|7|8|9)\d{9}|(?:\+1[ -]?)?[2-9]\d{2}[ -]?\d{3}[ -]?\d{4})$/),
    EMAIL_PATTERN: new RegExp(regexString),
    FIRST_HUNDRED_PATTERN: new RegExp(/^([1-9][0-9]?|100)$/),
    WHITE_SPACE_PATTERN: new RegExp(/^\S.*\S$|^$/),
    PROJECT_NOTES: new RegExp(/^[a-zA-Z0-9 ,.?!'-]+$/),
    USERNAME_PATTERN: new RegExp(/^[^\s]+$/),
    WEBSITE_PATTERN: new RegExp(/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9#-\/]*)?\/?$/),
  },
  staticImages: {
    icons: {
      dashboardActive: 'assets/images/icons/Dashboard-Active.svg',
      dashboard: 'assets/images/icons/Dashboard-icon.svg',
      customers: 'assets/images/icons/Customer-icon.svg',
      projects: 'assets/images/icons/Project-icon.svg',
      surveys: 'assets/images/icons/Survey-icon.svg',
      dashboardHover: 'assets/images/icons/Dashboard-Hover.svg',
      lockPassword: 'assets/images/icons/Lock-Password.svg',
      loginUser: 'assets/images/icons/Login-User.svg',
      addNew: 'assets/images/icons/Add-New.svg',
      onBoard: 'assets/images/icons/On-Board.svg',
    },
    images: {
      profileImgPlaceholder: 'assets/images/placeholder-profile-img.png',
      pageNotFound: 'assets/images/page-not-found.svg',
      headerLogout: 'assets/images/exit-right.svg',
      sidebarOff: 'assets/images/sidebar-off.svg',
      sidebarOn: 'assets/images/sidebar-on.svg',
    },
    loaders: {
      imageLoader: 'assets/loaders/image-loader.gif',
    },
  },
  successMessages: {
    changePassword: 'Password updated successfully',
    imageCompression: 'Image compression is complete successfully',
    deleteUser: 'User Deleted successfully',
    theme: 'Theme updated successfully',
    customerAdded: 'Customer added successfully',
    projectAdded: 'Project added successfully',
    emailAdded: 'Email added Successfully',
    emailChanged: 'Email changed Successfully',
    phoneAdded: 'Phone number added Successfully',
    phoneChanged: 'Phone number changed Successfully',
    stakeAdd: 'Stake Holder added successfully',
    stakeupdate: 'Stake Holder updated successfully',
    addressUpdate: 'Address updated successfully',
    BillingUpdate: 'Billing address updated successfully',
    descriptionUpdate: 'Description updated successfully',
    companySizeUpdated: 'Company Size updated successfully',
    verticalUpdated: 'Vertical updated successfully',
    accManagerUpdate: 'Account manager updated successfully',
    delManagerUpdate: 'Delivery manager updated successfully',
    phaseUpdate: 'Phase updated successfully',
    teamUpdate: 'Service Pillar updated successfully',
    projectStatusUpdate: 'Project status updated successfully',
    typeUpdate: 'Project type updated successfully',
    engagementUpdate: 'Engagement updated successfully',
    projectDescUpdate: 'Project description updated successfully',
    linkUpdate: 'Project link updated successfully',
    linkAdded: 'Project link addded successfully',
    linkDelete: 'Project link deleted successfully',
    notesUpdate: 'Project notes updated successfully',
    notesAdded: 'Project notes addded successfully',
    notesDelete: 'Project notes deleted successfully',
    teamAllocationUpdate: 'Team Allocation updated successfully',
    teamAllocationAdded: 'Team Allocation added successfully',
    teamAllocationDelete: 'Team Allocation deleted successfully',
    projectInvoiceAdded: 'Project Invoice added successfully',
    projectInvoiceUpdate: 'Project Invoice updated successfully',
    projectInvoiceDelete: 'Project Invoice deleted successfully',
    projectReportAdded: 'Project Report added successfully',
    projectStageDelete: 'deleted successfully',
    projectReportUpdate: 'Project Report updated successfully',
    projectReportDelete: 'Project Report delete successfully',
    projectStartDateUpdate: 'Project Start date updated successfully',
    projectEndDateUpdate: 'Project Actual End date updated successfully',
    projectSOWEndDateUpdate: 'Project SOW End date updated successfully',
    billingUpdate: 'Project billing updated successfully',
    projectKeyUpdate: 'Project key updated successfully',
    projectNameUpdate: 'Project name updated successfully',
    selectProjectReportStatus: 'Please select a project status',
  },
  infoMessages: {
    imageCompression: 'No compression needed. Image size is within the limit.',
    noDataFound: 'No data found.',
  },
  errorMessages: {
    email: 'Email is undefined',
    customerExists: 'Customer exists already',
    notFound: 'not found',
    invalidDetails: 'Please enter valid details',
    invalidEmail: 'Please enter a valid email',
    uniqueEmail: 'Email fields should be unique',
    invalidPhoneNo: 'Please enter a valid phone number',
    uniquePhoneNo: 'Phone number should be unique',
    validField: 'Please enter valid input',
    subsequentDate: 'Entered date should be greater than previously entered date',
  },
  date: {
    DD_MM_YYYY: 'dd MMM yyyy  ',
  },
};

export const LAYOUT_SCHEME = {
  isSidebarOnly: true,
  showFooter: true,
};

export const BILLING_OPTION = ['YEARLY', 'MONTHLY', 'QUARTERLY', 'WEEKLY', 'FIXED_COST', 'BLOCKS', 'MILESTONE'];

export enum PROGRESS_TYPES {
  spinner = 'spinner',
  progressBar = 'progressBar',
}

export enum POSITION_TYPES {
  PART_TIME = 'PART_TIME',
  FULL_TIME = 'FULL_TIME',
}

export enum STAGES {
  KICK_OFF = 'KICK_OFF',
  BUILD = 'BUILD',
  TESTING = 'TESTING',
  ON_HOLD = 'ON_HOLD',
  GO_LIVE = 'GO_LIVE',
}

export enum MILESTONES {
  KICK_OFF = 'KICK_OFF',
  CLOSE = 'CLOSE',
  SURVEY = 'SURVEY',
  ON_BOARD = 'ON_BOARD',
}

export enum ROLES {
  ACCOUNT_MANAGER = 1,
  DELIVERY_MANAGER,
}
